var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcDeliveryStatus = function SvgIcDeliveryStatus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 14,
    rx: 1,
    stroke: "#757575",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6C14 5.44771 14.4477 5 15 5H16.1139C17.1434 5 18.0047 5.78149 18.1045 6.80611L18.8932 14.9031C18.9504 15.4909 18.4885 16 17.8979 16H15C14.4477 16 14 15.5523 14 15V6Z",
    stroke: "#757575",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7998 16C11.7998 17.6146 12.9363 19.1535 14.5998 19.1535C16.2633 19.1535 17.3998 17.6146 17.3998 16H15.7998C15.7998 16.985 15.1454 17.5535 14.5998 17.5535C14.0542 17.5535 13.3998 16.985 13.3998 16H11.7998Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7998 16C3.79982 17.6146 4.93627 19.1535 6.5998 19.1535C8.26334 19.1535 9.39979 17.6146 9.39981 16H7.7998C7.79979 16.985 7.14539 17.5535 6.5998 17.5535C6.05422 17.5535 5.39982 16.985 5.3998 16H3.7998Z",
    fill: "#757575"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcDeliveryStatus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_delivery_status.ea64b097397acb3dc1f8ae4292e2d16e.svg";